import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";

function Reader() {
    const { id } = useParams(); // chapter id
    const [chapter, setChapter] = useState(null);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/chapters/${id}`)
            .then(res => setChapter(res.data))
            .catch(err => console.error(err));
    }, [id]);

    if (!chapter) return <p>Loading chapter...</p>;

    return (
        <div style={{
            background: "#111",
            color: "#fff",
            minHeight: "100vh",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        }}>
            <div style={{ width: "100%", maxWidth: "800px" }}>
                <Link to={`/comic/${chapter.comicId}`} style={{ color: "#0af", textDecoration: "none" }}>⬅ Back to Comic</Link>

                <h2 style={{ textAlign: "center", margin: "20px 0" }}>
                    Chapter {chapter.chapterNumber}: {chapter.title}
                </h2>



                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                    <Link
                        to={chapter.prevId ? `/read/${chapter.prevId}` : "#"}
                        style={{
                            color: "#fff",
                            padding: "10px",
                            background: chapter.prevId ? "#333" : "#555",
                            borderRadius: "5px",
                            pointerEvents: chapter.prevId ? "auto" : "none",
                            opacity: chapter.prevId ? 1 : 0.5
                        }}
                    >
                        ⬅ Prev
                    </Link>

                    <Link
                        to={chapter.nextId ? `/read/${chapter.nextId}` : "#"}
                        style={{
                            color: "#fff",
                            padding: "10px",
                            background: chapter.nextId ? "#007bff" : "#555",
                            borderRadius: "5px",
                            pointerEvents: chapter.nextId ? "auto" : "none",
                            opacity: chapter.nextId ? 1 : 0.5
                        }}
                    >
                        Next ➡
                    </Link>
                </div>

                <div>
                    {chapter.pages.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`Page ${index + 1}`}
                            loading="lazy"
                            style={{
                                width: "100%",
                                maxWidth: "800px",
                                height: "auto",
                                display: "block",
                                margin: "20px auto"
                            }}
                        />
                    ))}
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                    <Link
                        to={chapter.prevId ? `/read/${chapter.prevId}` : "#"}
                        style={{
                            color: "#fff",
                            padding: "10px",
                            background: chapter.prevId ? "#333" : "#555",
                            borderRadius: "5px",
                            pointerEvents: chapter.prevId ? "auto" : "none",
                            opacity: chapter.prevId ? 1 : 0.5
                        }}
                    >
                        ⬅ Prev
                    </Link>

                    <Link
                        to={chapter.nextId ? `/read/${chapter.nextId}` : "#"}
                        style={{
                            color: "#fff",
                            padding: "10px",
                            background: chapter.nextId ? "#007bff" : "#555",
                            borderRadius: "5px",
                            pointerEvents: chapter.nextId ? "auto" : "none",
                            opacity: chapter.nextId ? 1 : 0.5
                        }}
                    >
                        Next ➡
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Reader;
